module.exports = __webpack_public_path__ + "static/media/exchange-alt.870f68d4.svg";